<template>
  <h1
    class="choice-title"
    :class="{
      required: $store.getters?.getQuesInfo?.type === 1 && data.isRequired,
    }"
  >
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span
    >{{ data?.title }}<span v-if="$store.getters?.isShowType" class="title-tip"> (多选)</span>
    <template v-if="data.questionType == 1 && (data.minSelectNum || data.maxSelectNum)">
      <template v-if="data.minSelectNum == data.maxSelectNum">
        <span class="title-tip">（请选{{data.minSelectNum}}项）</span>
      </template>
      <template v-else>
        <span v-if="data.minSelectNum || data.maxSelectNum" class="title-tip">（</span>
        <span v-if="data.minSelectNum" class="title-tip">最少选{{data.minSelectNum}}项</span>
        <span v-if="data.minSelectNum && data.maxSelectNum" class="title-tip">，</span>
        <span v-if="data.maxSelectNum" class="title-tip">最多选{{data.maxSelectNum}}项</span>
        <span v-if="data.minSelectNum || data.maxSelectNum" class="title-tip">）</span>
      </template>
    </template>
  </h1>
  <div v-if="data.url" class="img-list">
    <li
      v-for="(item, index) in data.url && JSON.parse(data.url)"
      :key="`${item.url}${index}`"
    >
      <img
        @click="handleImgPreview(data.url && JSON.parse(data.url), index)"
        class="title-img"
        v-if="isImage(item.url)"
        :src="item.url"
        alt=""
      />
      <video
        class="title-video"
        controls
        v-else
        :poster="item.poster"
        :src="item.url"
        alt=""
      ></video>
    </li>
  </div>
  <Checkbox-Group
    class="choice"
    v-model="checked"
    @change="handleCheckBoxChange"
  >
    <template v-for="(item, index) in data?.optionVoList" :key="item.optionKey">
      <Checkbox
        shape="square"
        class="choice-item"
        :name="item.optionKey"
        :disabled="
          $store.getters?.getQuesInfo?.type === 1 && item.display === false
        "
      >
        {{ String.fromCharCode(65 + index) }}.{{ item.content }}
        <span
          class="choice-item-limit-tips"
          v-if="$store.getters?.getQuesInfo?.type === 1 && item.chance !== null"
          >{{ handleFormatlimitTips(item.chance) }}</span
        >
      </Checkbox>
      <Field
        v-model="inputValue[item.optionKey]"
        v-show="
          $store.getters.getQuesInfo.type === 1 &&
          checked.includes(item.optionKey) &&
          item.isBlank == 1
        "
        style="border-bottom: 1px solid #e0e0e0"
        :placeholder="item.remark ? item.remark : '请输入不满意原因'"
        type="textarea"
        rows="2"
        autosize
        border
      />
    </template>
  </Checkbox-Group>
  <template
    v-if="$store.getters.getQuesInfo.type === 3 && (showFeedBack || isReview)"
  >
    <div v-if="!showMultiSubmit">
      <div class="feedback">
        <div class="left green" v-if="isRight">答案：正确</div>
        <div class="left red" v-else>答案：错误</div>
        <div v-if="type !== '1'" class="right">
          正确答案：{{ rightAnswer.index }}
        </div>
      </div>
      <div
        v-if="
          data?.explanation &&
          $store.getters.getQuesSetting?.isExplanation === 2
        "
        class="explanation"
      >
        <img src="@/assets/img/explanation.png" alt="" />
        <p>解析：{{ data.explanation }}</p>
      </div>
    </div>
    <Button
      @click="
        () => {
          $emit('multiSubmit')
        }
      "
      v-else
      type="primary"
      class="multi-submit"
      >提交答案</Button
    >
  </template>
</template>

<script>
// 多选和单选的样式是一样的 提出来了
import './css/choice.scss'
import { Checkbox, CheckboxGroup, Button, Field } from 'vant'
import { ref, onMounted, watch, computed, reactive } from 'vue'
import { onBeforeRouteUpdate } from 'vue-router'
import { getQueryString, isImage, getAnswer, handleFormatlimitTips } from '@/utils/tools'
import { useStore } from 'vuex'
import { useImagePreview } from '@/hooks/index.js'

// 正确选项设置
const rightAnswerEffect = (data, rightAnswer) => {
  rightAnswer.value.index = ''
  rightAnswer.value.optionKey = []
  data.optionVoList.forEach((item, index) => {
    if (item.isRight) {
      rightAnswer.value.index += String.fromCharCode(65 + index)
      rightAnswer.value.optionKey.push(item.optionKey)
    }
  })
}

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
    currentChecked: {
      type: Array,
      default: () => [],
    },
    showFeedBack: {
      type: Boolean,
      default: false,
    },
    showMultiSubmit: {
      type: Boolean,
      default: false,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['changeChoice', 'radioSelect', 'multiSubmit'],
  components: { Checkbox, CheckboxGroup, Button, Field },
  setup(props, ctx) {
    const checked = ref([])
    const inputValue = reactive({})
    const store = useStore()

    // 选中
    const handleCheckBoxChange = (value) => {
      // 单个题
      ctx.emit('changeChoice', value)

      // 列表题
      const answers = formatRemarkContent(
        value,
        inputValue,
        props.data.questionKey
      )

      const commitData = {
        questionKey: props.data.questionKey,
        questionType: props.data.questionType,
        minSelectNum: props.data.minSelectNum,
        maxSelectNum: props.data.maxSelectNum,
        answers,
      }
      ctx.emit('radioSelect', commitData)
    }

    const rightAnswer = ref({
      optionKey: [],
      index: '',
    })

    // 只有问卷有
    if (store.getters.getQuesInfo.type === 1) {
      // 选项的填空
      watch(
        () => inputValue,
        (n) => {
          const answers = formatRemarkContent(
            checked.value,
            n,
            props.data.questionKey
          )
          const commitData = {
            questionKey: props.data.questionKey,
            questionType: props.data.questionType,
            answers,
          }
          ctx.emit('radioSelect', commitData)
        },
        { deep: true }
      )
    }

    watch(
      () => props.data,
      (n) => {
        rightAnswerEffect(props.data, rightAnswer)
      }
    )

    // 切换单多选时候会触发
    onMounted(() => {
      rightAnswerEffect(props.data, rightAnswer)
      checked.value = props.currentChecked

      const localAnswer = getAnswer(props.data.questionKey)
      if (localAnswer) {
        localAnswer.map((item) => {
          if (item.remarkContent) {
            inputValue[item.optionKey] = item.remarkContent
          }
        })
        checked.value = localAnswer?.map((item) => item.optionKey)
      }
    })

    // 连续多个相同题型时会触发
    onBeforeRouteUpdate(() => {
      checked.value = props.currentChecked
    })

    // 判断是否正确
    const isRight = computed(() => {
      return (
        rightAnswer.value.optionKey.length === checked.value.length &&
        rightAnswer.value.optionKey.sort().toString() ===
          checked.value.sort().toString()
      )
    })

    // 为了判断正式考试回顾不显示正确答案
    const type = getQueryString('type')

    // 图片预览展示
    const { handleImgPreview } = useImagePreview()

    return {
      checked,
      inputValue,
      handleCheckBoxChange,
      rightAnswer,
      isRight,
      type,
      handleImgPreview,
      isImage,
      handleFormatlimitTips,
    }
  },
}

// 提取remarkContent 填空内容
const formatRemarkContent = (checkedList, inputObj, questionKey) => {
  return checkedList.map((option) => {
    return {
      optionKey: option,
      questionKey: questionKey,
      remarkContent: inputObj[option] || '',
    }
  })
}
</script>
